import { render, staticRenderFns } from "./PostCollection.vue?vue&type=template&id=1781d2a8"
import script from "./PostCollection.vue?vue&type=script&lang=js"
export * from "./PostCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports